import { classNames } from "primereact/utils";
import { DeleteButton } from "../../components/TableButtons";
import { DataView } from "primereact/dataview";

export default function RequirementDataView({
  requirements,
  setRequirementList,
  setCenterSelected,
}) {
  function deleteRequirement(requirement) {
    const newList = requirements.filter((req) => req !== requirement);
    setRequirementList(newList);
    if (newList.length === 0) {
      setCenterSelected(null);
    }
  }

  const itemTemplate = (product, index) => {
    return (
      <div className="col-12" key={index}>
        <div
          className={classNames(
            "flex flex-column xl:flex-row xl:align-items-start p-3 gap-2",
            { "border-top-1 surface-border": index !== 0 }
          )}
        >
          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
            <div className="flex flex-column align-items-center sm:align-items-start gap-1">
              <div className="text-lg font-bold text-900">
                {product.requirementLabel}
              </div>
              <div className="text-900">{product.requirementTypeLabel}</div>

              {/* <Rating value={product.rating} readOnly cancel={false}></Rating> */}
              <div className="flex align-items-center gap-3">
                <span className="flex align-items-center gap-2">
                  <i className="pi pi-building-columns"></i>
                  <span className="text-sm font-semibold">
                    {product.medicalCenterLabel}{" "}
                    {product.subAdminMedicalCenterLabel &&
                      `(${product.subAdminMedicalCenterLabel})`}
                  </span>
                </span>
                {/* <Tag
                    value={product.inventoryStatus}
                    severity={getSeverity(product)}
                  ></Tag> */}
              </div>
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2 mr-4 sm:mr-0">
              <DeleteButton onClick={() => deleteRequirement(product)} />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div className="grid grid-nogutter">{list}</div>;
  };
  return <DataView value={requirements} listTemplate={listTemplate} />;
}
